// components/Accordion.tsx
import { useState } from "react";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  mainTitle?: string;
  fontSize?: string;
}

export default function Accordion({
  title,
  children,
  defaultOpen = false,
  mainTitle = "Asset Information :",
  fontSize,
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-300 rounded-lg mb-4 overflow-hidden">
      <button
        className="w-full px-6 py-4 text-left bg-white hover:bg-gray-50 flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        style={{ backgroundColor: "white" }}
      >
        <span
          className={`font-semibold text-gray-800 ${fontSize ? fontSize : "text-base"}`}
        >
          {mainTitle} {title}
        </span>
        <svg
          className={`w-5 h-5 transform transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="px-6 py-4 bg-white border-t border-gray-200">
          {children}
        </div>
      )}
    </div>
  );
}
